import { WebPlugin } from '@capacitor/core';
import { NavigationPluginPlugin } from '../../definitions';

export class NavigationPluginWeb extends WebPlugin implements NavigationPluginPlugin {
  onUnhandledNavigation: (options: { path: string; }) => void;

  constructor() {
    super({
      name: 'NavigationPlugin',
      platforms: ['web'],
    });
  }

  async goToNativeScreen(options: { path: string; caller?: string; }): Promise<{ value: string; }> {
    if (this.onUnhandledNavigation)
    {
      this.onUnhandledNavigation(options);
    }
    return { value: null };
  }
}
